import { useAtom } from 'jotai';
import { atomWithStorage, createJSONStorage } from 'jotai/utils';

const STORAGE_KEY = 'userPreferredMapType';

export type MapTypeId = 'roadmap' | 'satellite' | 'hybrid' | 'terrain';

const storage = createJSONStorage<MapTypeId>(() => sessionStorage);

const userPreferredMapTypeAtom = atomWithStorage<MapTypeId>(
  STORAGE_KEY,
  google.maps.MapTypeId.HYBRID as MapTypeId, // default map type
  storage,
);
userPreferredMapTypeAtom.debugLabel = STORAGE_KEY;

/**
 * Hook to manage the user's preferred map type.
 */
export const useUserPreferredMapType = () => {
  const [userPreferredMapType, setUserPreferredMapType] = useAtom(
    userPreferredMapTypeAtom,
  );

  return {
    userPreferredMapType,
    setUserPreferredMapType,
  };
};
